import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { routes } from "../../routes";
import { authManager } from "src/main";
import { portalApiClient } from "src/api/apiClient";
import { apiUrls } from "src/consts/ApiUrls";
import { ShowToast } from "src/components/Toast";
import { lang } from "src/language/Strings";
import { Spinner } from "src/components/LoadingSpinner";
import LoginComponent from "./LoginPage";

export function RedirectPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    // 1. Kolla om vi är i mitten av ett Microsoft-svar
    // MSAL sätter koden i URL:en (ofta efter ett # eller ?)
    const hasAuthCode = window.location.hash.includes("code=") || 
                        window.location.search.includes("code=");

    // 2. Om det finns en kod, rör ingenting! Låt MSAL sköta sitt.
    if (hasAuthCode) {
      return; 
    }
    authManager.listeners.add((state) => {
      if (state.isAuthenticated){
        portalApiClient
        .get(apiUrls.me)
        .then((res) => {
          if (res.status === 200) {
            navigate(routes.Map.url(res.data.companyId!, undefined));
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.error("API call failed:", err, err.message, err.stack);
          ShowToast(lang.errorGettingUser, "error", 3000);
          authManager.signOut();
          setIsLoading(false);
        });
      }
    })
    return () => {
    }
  }, []);

  return <>{isLoading ? <Spinner /> : <LoginComponent />}</>;
}